var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPackage = function SvgPackage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 468 468",
    height: 512,
    viewBox: "0 0 468 468",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 191.099 168.936 96.721 43.888-55.066-177.885-93.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.703 232.549 44.051 55.272 169.246-96.899-35.414-55.907z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.576 121.376 173.147 91.423 173.395-95.073-173.018-81.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.112 339.051 176.036 92.949v-164.475l-37.114 46.567c-4.212 5.286-11.647 6.709-17.513 3.35l-121.409-69.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.542 267.525v164.049l176.036-96.656v-86.987l-121.409 69.51c-5.865 3.357-13.301 1.935-17.512-3.35z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/package.168ed061.svg";
export { ForwardRef as ReactComponent };